import api from '../../../services/data.services'
import { authService } from '../../../services'

const familyGroupSrv = 'requests/families/groups'
const familyGroupFilterSrv = 'requests/families/groups/selections'
const relationshipsSrv = 'types/relationships'
const familySearchSrv = 'patients/searches'
const familyLegalTextSrv = 'legals/texts'

const getFamilies = async (patientId: number) => {
  try {
    const resp: any = await api.get(`${familyGroupSrv}/admin/patient-family-group?patient_id=${patientId}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp.data ? resp.data : [])
    }
  } catch(error: any) {
    return {
      status: 'Error',
      message: (error && error.msg ? error.msg : 'Error server al obtener grupo familiar')
    }
  }
}

const getFamiliesFilter = async () => {
  try {
    const resp: any = await api.get(`${familyGroupFilterSrv}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp.data ? resp.data : [])
    }
  } catch(error: any) {
    return {
      status: 'Error',
      message: (error && error.msg ? error.msg : 'Error server al obtener grupo familiar')
    }
  }
}

const getRelationships = async () => {
  try {
    const resp: any = await api.get(`${relationshipsSrv}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp.data ? resp.data : [])
    }
  } catch(error: any) {
    return {
      status: 'Error',
      message: (error && error.msg ? error.msg : 'Error server al obtener tipo de relación familiar')
    }
  }
}

const getFamily = async (documentTypeId: string, documentNumber: string) => {
  try {
    const resp: any = await api.get(`${familySearchSrv}/${documentTypeId}/${documentNumber}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : [])
    }
  } catch(error: any) {
    return {
      status: 'Error',
      message: (error && error.msg ? error.msg : 'Error server al obtener familiar')
    }
  }
}

const getFamilyLegalText = async (proccessName: string = 'family_group') => {
  try {
    const resp: any = await api.get(`${familyLegalTextSrv}/${proccessName}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.legalTexts ? resp.data.legalTexts : {})
    }
  } catch(error: any) {
    return {
      status: 'Error',
      message: (error && error.msg ? error.msg : 'Error server al obtener información legal del familiar')
    }
  }
}

const postFamilyGroup = async (data: any) => {
  try {
    const resp: any = await api.post(`${familyGroupSrv}/admin/patient-family-group`, data, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : {})
    }
  } catch(error: any) {
    return {
      status: 'Error',
      message: (error?.errors && Array.isArray(error.errors) && error.errors.length > 0) 
        ? error.errors[0].msg 
        : (error?.msg || 'Error al agregar integrante al grupo familiar')
    }
  }
}

const delFamilyGroup = async (id: number) => {
  try {
    const resp: any = await api.del(`${familyGroupSrv}/admin/patient-family-group`, id, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : {})
    }
  } catch(error: any) {
    return {
      status: 'Error',
      message: (error && error.errors.length ? error.errors[0].msg : 'Error server al eliminar familiar')
    }
  }
}

const getFamilyGroupsAsMember = async (patientId: number) => {
  try {
    const resp: any = await api.get(`${familyGroupSrv}/admin/patient-family-groups-as-member?patient_id=${patientId}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : [])
    }
  } catch(error: any) {
    return {
      status: 'Error',
      message: (error && error.msg ? error.msg : 'Error server al obtener grupo familiar')
    }
  }
}

const getPatientSentRequests = async (patientId: number) => {
  try {
    const resp: any = await api.get(`${familyGroupSrv}/admin/patient-requests/sent?patient_id=${patientId}`, authService.getToken())
    return {
      status: 'Ok',
      data: resp.data?.requests || []
    }
  } catch(error: any) {
    return {
      status: 'Error',
      message: error?.msg || 'Error al obtener solicitudes enviadas'
    }
  }
}

const getPatientReceivedRequests = async (patientId: number) => {
  try {
    const resp: any = await api.get(`${familyGroupSrv}/admin/patient-requests/received?patient_id=${patientId}`, authService.getToken())
    return {
      status: 'Ok',
      data: resp.data?.requests || []
    }
  } catch(error: any) {
    return {
      status: 'Error',
      message: error?.msg || 'Error al obtener solicitudes recibidas'
    }
  }
}

const acceptPatientRequest = async (requestId: number, applicantId: number, familyId: number) => {
  try {
    const resp: any = await api.get(
      `${familyGroupSrv}/admin/patient-requests/accept/${requestId}/${applicantId}/${familyId}`, 
      authService.getToken()
    )
    return {
      status: 'Ok',
      data: resp.data
    }
  } catch(error: any) {
    return {
      status: 'Error',
      message: error?.msg || 'Error al aceptar solicitud'
    }
  }
}

const rejectPatientRequest = async (requestId: number, applicantId: number, familyId: number) => {
  try {
    const resp: any = await api.get(
      `${familyGroupSrv}/admin/patient-requests/reject/${requestId}/${applicantId}/${familyId}`, 
      authService.getToken()
    )
    return {
      status: 'Ok',
      data: resp.data
    }
  } catch(error: any) {
    return {
      status: 'Error',
      message: error?.msg || 'Error al rechazar solicitud'
    }
  }
}

export const adminFamilyGroupService = {
  getFamilies,
  getFamiliesFilter,
  getFamilyGroupsAsMember,
  getRelationships,
  getFamily,
  getFamilyLegalText,
  postFamilyGroup,
  delFamilyGroup,
  getPatientSentRequests,
  getPatientReceivedRequests,
  acceptPatientRequest,
  rejectPatientRequest
}